import styles from '../Navigation.module.scss'
import NavigationItem from '../navigation-item/NavigationItem.tsx'
import { useTranslation } from 'react-i18next'
import { routes } from 'types/routes.ts'
import { useLocation } from 'react-router'
import AddressSwitcher from 'components/address-switcher/AdressSwitcher.tsx'
import { useLayoutEffect } from 'react'
import { useStoreSelector } from 'hooks/store.ts'
import { selectIsProducerAccount } from 'store/contact/slice.ts'

const BottomAppNavigation = () => {
  // i18n
  const { t } = useTranslation()
  const { accounts, selected } = useStoreSelector((store) => store.contact)
  const isProducer = useStoreSelector(selectIsProducerAccount)
  const accountContracts = accounts?.[selected?.account]?.billingContracts

  // Router
  const { pathname } = useLocation()
  const routesWithAddressSwitcher = [
    routes.OVERVIEW,
    routes.CONSUMPTION_ELECTRICITY,
    routes.CONSUMPTION_GAS,
    routes.CONSUMPTION_METER_READINGS,
    routes.BILLING,
    routes.PRODUCER,
    routes.USER_CONTACT,
    routes.USER_PAYMENT
  ]
  const hasAddressSwitcher = routesWithAddressSwitcher.some((route) => pathname.includes(route)) && accountContracts?.length > 1

  useLayoutEffect(() => {
    const variableSelector = '--bottom-bar-height'
    const bottomBarHeight = getComputedStyle(document.documentElement).getPropertyValue(variableSelector)

    // Only update CSS variable if necessary
    if (bottomBarHeight !== '0px') {
      if (bottomBarHeight !== '70px' && !hasAddressSwitcher) {
        document.documentElement.style.setProperty(variableSelector, '70px')
      } else if (bottomBarHeight !== '140px' && hasAddressSwitcher) {
        document.documentElement.style.setProperty(variableSelector, '140px')
      }
    }
  }, [hasAddressSwitcher])

  return (
    <nav className={styles['bottom-navigation']} aria-labelledby="main">
      {hasAddressSwitcher && <AddressSwitcher isMobile />}
      <ul className={styles['nav-items-list']}>
        <NavigationItem icon="homeSmileOutline" activeIcon="homeSmile" text={t(($) => $.nav.overview)} url={routes.OVERVIEW} />
        <NavigationItem
          icon="chartsOutline"
          activeIcon="charts"
          text={t(($) => $.nav[isProducer ? 'injection' : 'usage'])}
          extraActiveRoutes={[routes.CONSUMPTION]}
          url={routes.CONSUMPTION_ELECTRICITY}
        />
        <NavigationItem
          icon="fileOutline"
          activeIcon="file"
          text={t(($) => $.nav.billing)}
          extraActiveRoutes={[routes.BILLING]}
          overrideInactive={[routes.BILLING_CYCLES]}
          url={routes.BILLING_INVOICES}
        />
        <NavigationItem icon="menu" text={t(($) => $.nav.more)} url={routes.MORE} />
      </ul>
    </nav>
  )
}

export default BottomAppNavigation
